import controller from './wf-affect-history.controller';
import template from './wf-affect-history.html';

export default {
	controller,
	template,
	bindings: {
		options:         '<',
		affectKid:       '<',
	},
};
